export function zhDatetime(t) {
    if (t == "" || t == null || t == undefined) {
        return ''
    } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : '0' + M;
        D = D > 9 ? D : '0' + D;
        h = h > 9 ? h : '0' + h;
        m = m > 9 ? m : '0' + m;
        s = s > 9 ? s : '0' + s;
        return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
    }
}
export function pushMode(val) { //推送模式
    var arr = val.split(",")
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] == "0") {
            arr[i] = "邮箱发送"
        } else if (arr[i] == "1") {
            arr[i] = "短信发送"
        } else if (arr[i] == "2") {
            arr[i] = "APP推送"
        } else if (arr[i] == "3") {
            arr[i] = "小程序推送"
        } else if (arr[i] == "4") {
            arr[i] = "语音拨号提醒"
        }
    }
    return arr.join(",")
}

export function zhDatetime1(t) {
    if (t == "" || t == null || t == undefined) {
        return ''
    } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : '0' + M;
        D = D > 9 ? D : '0' + D;
        h = h > 9 ? h : '0' + h;
        m = m > 9 ? m : '0' + m;
        s = s > 9 ? s : '0' + s;
        return Y + "/" + M + "/" + D + " " + h + ":" + m;
    }
}
export function zhDate(t) {
    if (t == "" || t == null || t == undefined) {
        return ''
    } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : '0' + M;
        D = D > 9 ? D : '0' + D;
        h = h > 9 ? h : '0' + h;
        m = m > 9 ? m : '0' + m;
        s = s > 9 ? s : '0' + s;
        return Y + "-" + M + "-" + D;
    }
}
export function zhDate1(t) {
    if (t == "" || t == null || t == undefined) {
        return ''
    } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : '0' + M;
        D = D > 9 ? D : '0' + D;
        h = h > 9 ? h : '0' + h;
        m = m > 9 ? m : '0' + m;
        s = s > 9 ? s : '0' + s;
        return Y + "年" + M + "月" + D + '日';
    }
}
export function zhDate2(t) {
    if (t == "" || t == null || t == undefined) {
        return ''
    } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : '0' + M;
        D = D > 9 ? D : '0' + D;
        h = h > 9 ? h : '0' + h;
        m = m > 9 ? m : '0' + m;
        s = s > 9 ? s : '0' + s;
        return Y + "/" + M + "/" + D;
    }
}
export function zhDate3(t) {
    if (t == "" || t == null || t == undefined) {
        return ''
    } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : '0' + M;
        D = D > 9 ? D : '0' + D;
        h = h > 9 ? h : '0' + h;
        m = m > 9 ? m : '0' + m;
        s = s > 9 ? s : '0' + s;
        return Y;
    }
}
export function zhDate4(t) {
    if (t == "" || t == null || t == undefined) {
        return ''
    } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : '0' + M;
        D = D > 9 ? D : '0' + D;
        h = h > 9 ? h : '0' + h;
        m = m > 9 ? m : '0' + m;
        s = s > 9 ? s : '0' + s;
        return M + "/" + D;
    }
}

export function isStaffFormat(val) { // 可删除
    if (val == 1) {
        return '是'
    } else if (val == 2) {
        return '否'
    }
}

// 状态
export function statusM(val) {
    if (val == 0) {
        return '启用'
    } else if (val == 1) {
        return '冻结'
    }
}

// 保留两位小数
export function smallNum(val) {
    return val ? val.toFixed(2) : '0:00'
}

// 协议类型 0动态16条线路简化101协议，1动态10条线路带过流带电池电压简化101协议，2标准平衡101协议，3标准104规约
export function protocolType(val) {
    if (val == 0) {
        return '动态16条线路简化101协议'
    } else if (val == 1) {
        return '动态10条线路带过流带电池电压简化101协议'
    } else if (val == 2) {
        return '标准平衡101协议'
    } else if (val == 3) {
        return '标准104规约'
    }
}

// 状态
export function statusOnline(val) {
    if (val == 0) {
        return '离线'
    } else if (val == 1) {
        return '在线'
    }
}

// 文件类型
export function fileType(val) {
    if (val == 0) {
        return '配置文件'
    }
}

// 状态
export function loginType(val) {
    if (val == 0) {
        return 'PC'
    } else if (val == 1) {
        return 'APP'
    } else {
        return ''
    }
}
// 状态
export function sendType(val) {
    if (val == 0) {
        return '短信'
    } else if (val == 1) {
        return 'APP'
    }
}


// 状态
export function loginSta(val) {
    if (val == 0) {
        return '成功'
    } else if (val == 1) {
        return '失败'
    }
}

// 变位
export function displacement(val) {
    if (val == 0) {
        return '关'
    } else if (val == 1) {
        return '开'
    }
}

// 点类型
export function pointType(val) {
    if (val == 0) {
        return '单点'
    } else if (val == 1) {
        return '双点'
    }
}
// 消息类型（0设备消息，1系统公告）approveScene
export function messageType(val) {
    if (val == 0) {
        return '设备消息'
    } else if (val == 1) {
        return '系统公告'
    }
}
// 审批场景（0生长模型，1决策模型）
export function approveScene(val) {
    if (val == 0) {
        return '生长模型'
    } else if (val == 1) {
        return '决策模型'
    }
}
// 启用停用
export function isOpen(val) {
    if (val == 0) {
        return '停用'
    } else if (val == 1) {
        return '启用'
    }
}
// 时间
export function intervalTime(val) {
    if (val == undefined || val == '') {
        return ''
    } else {
        return val + 's'
    }
}
// 开关类型
export function switchType(val) { //开关类型 0无状态基础开关、1无状态模拟开关、2只读开关 开关基础表也有这个字段（冗余字段 加快效率） 3有状态基础开关、4有状态模拟开关
    if (val == 0) {
        return '无状态基础开关'
    } else if (val == 1) {
        return '无状态模拟开关'
    } else if (val == 2) {
        return '只读开关'
    } else if (val == 3) {
        return '有状态基础开关'
    } else if (val == 4) {
        return '有状态模拟开关'
    } else if (val == 5) {
        return "正反转开关"
    } else if (val == 6) {
        return "展开收缩开关"
    } else if (val == 7) {
        return "下发开关"
    }
}

// 协议类型(0TCP, 1MQTT, 2COAP, 3LORA, 4MODBUS）
export function protocolTypes(val) {
    if (val == 0) {
        return 'TCP'
    } else if (val == 1) {
        return 'MQTT'
    } else if (val == 2) {
        return 'COAP'
    } else if (val == 3) {
        return 'LORA'
    } else if (val == 4) {
        return 'MODBUS'
    } else if (val == 5) {
        // return '有状态模拟开关'
    }
}
export function executionValue(val) { //基础开关：状态，0，1，：）
    if (val == 0) {
        return '关'
    } else if (val == 1) {
        return '开'
    } else if (val == 2) {
        return '模拟开关'
    }
}

export function pushusertype(val) {
    if (val == 0) {
        return '手机号'
    } else if (val == 1) {
        return '邮箱'
    }
}

export function logtype(val) {
    if (val == 0) {
        return '操作日志'
    } else if (val == 2) {
        return '定时任务'
    }
}

export function zhDatetime2(t) { //格式化时间
    if (t == "" || t == null || t == undefined) {
        return ''
    } else {
        var d = new Date();
        d.setTime(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        var hm = (t / 1000).toString().split(".")[1]
        if (hm.length == 0) {
            hm = hm + "0" + "0" + "0"
        } else if (hm.length == 1) {
            hm = hm + "0" + "0"
        } else if (hm.length == 2) {
            hm = hm + "0"
        }

        M = M > 9 ? M : '0' + M;
        D = D > 9 ? D : '0' + D;
        h = h > 9 ? h : '0' + h;
        m = m > 9 ? m : '0' + m;
        s = s > 9 ? s : '0' + s;
        return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s + "." + hm;
    }
}
export function zhDatetime3(t) {
    if (t == "" || t == null || t == undefined) {
        return ''
    } else {
        var d = new Date();
        d.setTime(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        M = M > 9 ? M : '0' + M;
        D = D > 9 ? D : '0' + D;
        return Y + "-" + M + "-" + D;
    }
}
export function statusFormat(val) { //是否职员状态
    if (val == 1) {
        return '启用'
    } else if (val == 2) {
        return '禁用'
    }
}

export function timeType(val) { //时间类型
    if (val == 0) {
        return '重复'
    } else if (val == 1) {
        return '一次'
    }
}
export function executionWeek(val) { //时间处理转换
    var arr = val.split(",")
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] == "1") {
            arr[i] = "一"
        } else if (arr[i] == "2") {
            arr[i] = "二"
        } else if (arr[i] == "3") {
            arr[i] = "三"
        } else if (arr[i] == "4") {
            arr[i] = "四"
        } else if (arr[i] == "5") {
            arr[i] = "五"
        } else if (arr[i] == "6") {
            arr[i] = "六"
        } else if (arr[i] == "7") {
            arr[i] = "七"
        }
    }
    var arrstr = "每周" + arr.join("、")
    return arrstr
}

export function status(val) {
    if (val == 0) {
        return '离线'
    } else if (val == 1) {
        return '在线'
    } else if (val == 2) {
        return '告警'
    }
}
export function storetype(val) { //设备属性存储位置
    if (val == 0) {
        return 'mysql'
    } else if (val == 1) {
        return 'influxdb'
    } else if (val == 2) {
        return 'mongodb'
    }
}

export function kztype(val) { //控制类型
    if (val == 0) {
        return '定时'
    } else if (val == 1) {
        return '自动'
    } else if (val == -1) {
        return '手动'
    }
}

export function dataType(val) { //设备属性数据类型
    if (val == 0) {
        return '枚举型'
    } else if (val == 1) {
        return '数值型 '
    } else if (val == 2) {
        return '布尔型'
    }
}
export function dataTransferType(val) { //设备属性数据类型
    if (val == 1) {
        return '只上报'
    } else if (val == 2) {
        return '可上报可下发'
    }
}
export function mstype(val) { //设备主题消息类型
    if (val == 0) {
        return 'update'
    } else if (val == 1) {
        return 'get'
    } else if (val == 2) {
        return 'error'
    }
}
export function qos(val) { //设备主题服务质量
    if (val == 0) {
        return '至多一次(QoS)'
    } else if (val == 1) {
        return '至少一次(QoS)'
    } else if (val == 2) {
        return '只有一次(QoS)'
    }
}
export function endian(val) { //字节序
    if (val == 1) {
        return '小端'
    } else if (val == 0) {
        return '大端'
    }
}
export function switchStatus(val) {
    if (val == 0) {
        return '关闭'
    } else if (val == 1) {
        return '开启'
    }
}
export function accounttype(val) {
    if (val == 0) {
        return '手机号'
    } else if (val == 1) {
        return '邮箱'
    }
}

export function logotype(val) {
    if (val == 0) {
        return 'PC端'
    } else if (val == 1) {
        return 'APP'
    } else if (val == 2) {
        return '定时任务'
    }
}

export function switchStatus2(val) {
    if (val == 0) {
        return '停止'
    } else if (val == 1) {
        return '正开'
    } else if (val == 2) {
        return '反开'
    }
}
export function switchStatus3(val) {
    if (val == 0) {
        return '展开停止'
    } else if (val == 1) {
        return '收缩停止'
    } else if (val == 2) {
        return '展开'
    } else if (val == 3) {
        return '收缩'
    }
}
export function switchType2(val) {
    if (val == 0) {
        return '无状态基础开关 '
    } else if (val == 1) {
        return '无状态模拟开关'
    } else if (val == 2) {
        return '只读类型'
    } else if (val == 3) {
        return '有状态基础开关'
    } else if (val == 4) {
        return '有状态模拟开关'
    } else if (val == 5) {
        return '正反转开关'
    } else if (val == 6) {
        return '展开伸缩开关'
    }
}

export function gender(val) {
    if (val == 0) {
        return '男 '
    } else if (val == 1) {
        return '女'
    }
}

export function range(val) { //字节序
    if (val == "01") {
        return '01-线圈状态(Coil Status)'
    } else if (val == "02") {
        return '02-输入状态(Input Status)(1X)'
    } else if (val == "03") {
        return '03-保持寄存器(Holding Register)'
    } else if (val == "04") {
        return '04-输入寄存器(Input Register)(3X)'
    }
}

export function devicetype(val) { //设备类型
    if (val == "0") {
        return '数值设备'
    } else if (val == "1") {
        return '视频设备'
    } else if (val == "2") {
        return '图片设备'
    } else if (val == "3") {
        return '开关设备'
    }
}
export function devicexy(val) { //设备协议类型
    if (val == "0") {
        return 'mqtt'
    } else if (val == "1") {
        return 'coap'
    } else if (val == "2") {
        return 'ModbusTCP'
    } else if (val == "3") {
        return 'ModbusRTU'
    } else if (val == "4") {
        return 'TCP'
    } else if (val == "5") {
        return 'BACNET'
    } else if (val == "6") {
        return 'SNMP'
    } else if (val == "7") {
        return 'OPC'
    } else if (val == "8") {
        return '212协议'
    }
}

export function usertype(val) { //系统管理员类型
    if (val == "0") {
        return '管理员'
    } else if (val == "1") {
        return '测试用户'
    } else if (val == "2") {
        return '普通用户'
    }
}
export function zxtype(val) { //执行类型
    if (val == "0") {
        return '立即执行'
    } else if (val == "1") {
        return '按定时条件执行'
    }
}
export function executeType(val) { //执行类型
    if (val == "0") {
        return '立即执行'
    } else if (val == "1") {
        return '按定时条件执行'
    }
}
export function activePushStatus(val) { //主动推送
    if (val == "0") {
        return '关闭'
    } else if (val == "1") {
        return '开启'
    }
}
export function colorType(val) { //告警颜色
    if (val == "1") {
        return '浅黄色'
    } else if (val == "2") {
        return '黄色'
    } else if (val == "3") {
        return '橙色'
    } else if (val == "4") {
        return '红色'
    }
}

export function deviceStatus(val) { //设备状态
    if (val == "1") {
        return '在线'
    } else if (val == "0") {
        return '离线'
    } else if (val == "2") {
        return '告警'
    }
}

export function SendType(val) { //设备状态SendType0下发一次，1一直下发，2检测开关状态下发）
    if (val == "1") {
        return '一直下发'
    } else if (val == "0") {
        return '下发一次'
    } else if (val == "2") {
        return '检测开关状态下发'
    } else if (val == "3") {
        return '下发二次'
    } else if (val == "5") {
        return '检测触发次数下发'
    }
}

export function paramTypeName(paramType) { // 参数类型名称
    let paramTypeName = "";
    let arr = paramTypeArray();
    arr.forEach(val => {
        if (val.id == paramType) {
            paramTypeName = val.name;
            return;
        }
    });

    return paramTypeName;
}

export function paramTypeUnit(paramType) { // 参数类型单位
    let paramTypeUnit = "";
    let arr = paramTypeArray();
    arr.forEach(val => {
        if (val.id == paramType) {
            paramTypeUnit = val.unit;
            return;
        }
    });

    return paramTypeUnit;
}


export function paramTypeArray() { // 参数类型数组
    let arr = [{
            id: 1,
            name: "土壤湿度",
            unit: "%rh",
        },
        {
            id: 2,
            name: "土壤温度",
            unit: "℃",
        },
        {
            id: 3,
            name: "土壤PH",
            unit: "",
        },
        {
            id: 4,
            name: "土壤盐分",
            unit: "us/cm",
        },
        {
            id: 5,
            name: "土壤紧实度",
            unit: "pa",
        },
        {
            id: 6,
            name: "叶片温度",
            unit: "℃",
        },
        {
            id: 7,
            name: "叶片湿度",
            unit: "%rh",
        },
        {
            id: 8,
            name: "冠层温度",
            unit: "℃",
        },
        {
            id: 9,
            name: "光照时长",
            unit: "h",
        },
        {
            id: 10,
            name: "空气温度",
            unit: "℃",
        },
        {
            id: 11,
            name: "空气湿度",
            unit: "%rh",
        },
        {
            id: 12,
            name: "CO2",
            unit: "ppm",
        },
        {
            id: 13,
            name: "光照强度",
            unit: "lux",
        },
        {
            id: 14,
            name: "光合有效辐射",
            unit: "umol*m-2*s-1",
        },
        {
            id: 15,
            name: "大气压强",
            unit: "kpa",
        },
        {
            id: 16,
            name: "水氮",
            unit: "mg/L",
        },
        {
            id: 17,
            name: "水磷",
            unit: "mg/L",
        },
        {
            id: 18,
            name: "水钾",
            unit: "mg/L",
        },
        {
            id: 19,
            name: "水温",
            unit: "℃",
        },
        {
            id: 20,
            name: "水氧",
            unit: "mg/L",
        },
    ];

    return arr;
}